class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: 'header'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.toggleHeaderScrollClass();

		$(window).on('scroll', () => {
			this.toggleHeaderScrollClass();
		});
	}

	toggleHeaderScrollClass() {
		let scrollTop = $(window).scrollTop();

		if (scrollTop > .1) {
			this.$scope.addClass('scrolling');
		} else {
			this.$scope.removeClass('scrolling');
		}
	}
}

export default new Header;